import { render, staticRenderFns } from "./UserStorico.vue?vue&type=template&id=3884b163&"
import script from "./UserStorico.vue?vue&type=script&lang=js&"
export * from "./UserStorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports